export default function DOM_Text() {
  return (
    <div>
      <h1>DOM_Text</h1>
      <p>This is the DOM_Text component.</p>
    </div>
  );
}